// import Timer from './_Timer.js'
import 'hammerjs'

function zeropadding(i, length) {
  return ('00000' + i).slice(length * -1)
}

function clickPrev(_) {
  this.index = Math.max(this.index - 1, 0)
  this.updateDOM()
}
function clickNext(_) {
  this.index = Math.min(this.index + 1, this.items.length - 1)
  this.updateDOM()
}
function cancel(e) {
  e.preventDefault()
  e.stopPropagation()
  return false
}

class Slider {
  constructor(el) {
    this.$el = el
    this.items = this.$el.querySelectorAll('.js-slider--item')
    
    this.index = 0
    this.next = el.querySelector('.js-slider--next')
    this.prev = el.querySelector('.js-slider--prev')
    // this.destroyButton = el.querySelector('.js-slider--destroy')

    this.readout_current = el.querySelector('.js-slider--current')
    el.querySelector('.js-slider--total').innerText = `${this.items.length}`
    this.bind()
    this.updateDOM()
  }
  bind() {

    this.cancel = cancel.bind(this)
    // this.destroyButton.addEventListener('click', this.destroy.bind(this))

    this.clickPrev = clickPrev.bind(this)
    this.clickNext = clickNext.bind(this)
    this.prev.addEventListener('click', this.clickPrev)
    this.next.addEventListener('click', this.clickNext)

    // cancel original event
    this.$el.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', this.cancel)
      a.hammer = new Hammer(a)
      a.hammer.on('tap', e  => {
        if(a.getAttribute('target') === '_blank') {
          window.open(a.getAttribute('href'), '_blank')
        } else {
          location.href = a.getAttribute('href')

        }

        // return false
      })
    })
    
    this.hammer = new Hammer(this.$el)
    // this.hammer.get('swipe').set({
    //   direction: Hammer.DIRECTION_HORIZONTAL,
    //   threshold: 1,
    //   velocity:0.000001
    // });
    // this.hammer.on('swipe', e => {
    //   switch (e.direction) {
    //     case 2:
    //       this.clickNext()
    //       break;
    //       case 4:
    //       this.clickPrev()
    //       break;
    //   }
    // })
    this.hammer.on('panleft panright', e => {
      switch (e.type) {
        case 'panleft':
          this.clickNext()
          break;
        case 'panright':
          this.clickPrev()
          break;
      }
    })

  }
  cancelEvent(e) {
    e.preventDefault()
    e.stopPropagation()
    return false
  }
  updateDOM() {
    
    this.$el.dataset.index = this.index
    this.$el.classList.toggle('--active', this.items.length > 2)
    this.readout_current.innerText = `${this.index + 1}`
    this.prev.classList.toggle('--disabled', this.index === 0)
    this.next.classList.toggle('--disabled', this.index === this.items.length - 1)
  }
  destroy() {
    this.$el.dataset.index = null
    this.hammer.destroy()
    this.$el.querySelectorAll('a').forEach(a => {
      a.hammer.destroy()
      a.removeEventListener('click', this.cancel)
    })
    this.prev.removeEventListener('click', this.clickPrev)
    this.next.removeEventListener('click', this.clickNext)
  }
}
export default Slider;




// class CrossFade {
//   constructor() {
//     this.timer = null
//     this.speed = 5000
//     this.index = 0
//   }

//   init() {
//     this.el = document.querySelectorAll('.js-crossfade')
//     if(this.el.length) {
//       this.el.forEach(el => {
//         const length = el.querySelectorAll('.c-crossfader__item').length
//         if(length <= 1) {
//           el.classList.add('is-disabled')
//         }
//       })
//       this.start()
//     }
//   }

//   start() {
//     this.timer = setInterval(this.frame.bind(this), this.speed)
//   }
//   frame() {
//     this.index += 1
//     this.el.forEach(el => {
//       const length = el.querySelectorAll('.c-crossfader__item').length
//       el.dataset.crossfadeIndex = (this.index) % length
//     })
//   }
//   destroy() {
//     clearInterval(this.timer)
//     this.el.forEach(el => {
//       el.remove()
//     })
//   }
// }
